import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangePasswordComponent } from './change-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChangePasswordService } from './change-password.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [ChangePasswordComponent],
  exports: [ChangePasswordComponent],
  providers: [ChangePasswordService]
})
export class ChangePasswordModule { }



// WEBPACK FOOTER //
// ./src/app/pages/change-password/change-password.module.ts